var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8dd463;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2,834.33c1.31-1.73,15.41-19.72,40.41-19.6,24.69.12,38.54,17.8,39.9,19.6,1.36-1.46,14.51-15,34.39-13.07a41.53,41.53,0,0,1,26.14,13.07c13.19-28,43.33-44.38,72.92-40.5,37.12,4.86,52.93,38.86,53.66,40.5,23.37-43.22,69.62-71,120.34-72.21,53.14-1.26,102.75,26.88,127.3,72.21,3.67-6.05,18.62-29.07,47.91-36.6,32.78-8.43,70.14,6,92.42,36.6,2.16-3.36,24.5-36.73,67.55-39.67A88.76,88.76,0,0,1,805,834.33c18.11-39.78,60.17-64.4,104-61.42,38.79,2.65,73.2,26.49,88.85,61.42,23.47-45.56,71.5-75.14,124.37-76.52,55.6-1.44,107.44,28.55,132.21,76.52,4.62-3.62,24.83-18.63,54.11-17a80.38,80.38,0,0,1,44.94,17c3-4.36,23.56-33.28,62.28-37.84,32.42-3.82,65,10.91,84.17,37.84v245.92H2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects13);
export default __webpack_public_path__ + "static/media/objects-13.0daf25f16c20986c02904da2711ba887.svg";
export { ForwardRef as ReactComponent };